// Корневой компонент App — оборачивает router в ThemeModeProvider (AppProviders).
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from '@/theme/AppProviders';
import { router } from '@/router/AppRoutes';

/** Корневой App — providers + router. */
export function App(): JSX.Element {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
